export default __webpack_public_path__ + "static/media/Astros.e3fba2b0.png";